import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SignalWifiStatusbarConnectedNoInternet4 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18h2v2h-2zm0-8h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4z"
  }));
});
SignalWifiStatusbarConnectedNoInternet4.displayName = 'SignalWifiStatusbarConnectedNoInternet4';
export var SignalWifiStatusbarConnectedNoInternet4Dimensions = {
  height: 24,
  width: 24
};